import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FJUtil from '../../../util/FJUtil';

class FJAnchor extends Component {
    render() {
        const { zIndex, isTopLayer } = this.props;
        let index = 0;
        const isSafari = FJUtil.getBrowser() === 'Safari';

        if (zIndex) {
            index = zIndex;
        } else if (isTopLayer) {
            index = 999999;
        } else {
            index = isSafari ? 99 : 'inherit';
        }

        return ReactDOM.createPortal(
            <div
                style={{
                    position: isSafari ? 'fixed' : 'absolute',
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0,
                    zIndex: index,
                }}
            >
                {this.props.children}
            </div>,
            document.body,
        );
    }
}

export default FJAnchor;
